import React from 'react'
import { Dropdown, Button } from 'element-react'

const DropDownSG = () => {
    return (
        <div>
            <Dropdown
                menu={
                    <Dropdown.Menu>
                        <Dropdown.Item>Action 1</Dropdown.Item>
                        <Dropdown.Item>Action 2</Dropdown.Item>
                        <Dropdown.Item>Action 3</Dropdown.Item>
                        <Dropdown.Item>Action 4</Dropdown.Item>
                        <Dropdown.Item>Action 5</Dropdown.Item>
                    </Dropdown.Menu>
                }
            >
                <Button type="primary" className="margin-right-small">
                    {' '}
                    Dropdown List
                    <i className="el-icon-caret-bottom el-icon--right"></i>
                </Button>
            </Dropdown>
            <Dropdown
                splitButton={true}
                type="primary"
                onClick={() => null}
                menu={
                    <Dropdown.Menu>
                        <Dropdown.Item>Action 1</Dropdown.Item>
                        <Dropdown.Item>Action 2</Dropdown.Item>
                        <Dropdown.Item>Action 3</Dropdown.Item>
                        <Dropdown.Item>Action 4</Dropdown.Item>
                        <Dropdown.Item>Action 5</Dropdown.Item>
                    </Dropdown.Menu>
                }
            >
                Dropdown List
            </Dropdown>
        </div>
    )
}

export default DropDownSG
